import React from 'react';
import { Checkbox } from 'antd';

function CustomCheckBox({ state, setState, label }) {
  const handleCheck = (e) => {
    setState(e.target.checked);
  };

  return (
    <Checkbox checked={state} onChange={handleCheck}>
      {label}
    </Checkbox>
  );
}

export default CustomCheckBox;
